/**
 * Created by sachinprakash on 12/8/19.
 */
import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { shopPriceList } from '../constants/constants';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const ShopPriceListPage = React.lazy(() => import('../pages/ShopPriceListPage/ShopPriceListPage'));

const ShopPriceListSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={shopPriceList} exact component={ShopPriceListPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default ShopPriceListSettingsRoutes;
